<div class="dashboard-tutorial-dialog">
  <div class="dialog-content">
    <div class="dialog-body">
      <h2 class="title">{{ data.title }}</h2>
      <p class="message">{{ data.subTitle }}</p>

      <img src="assets/images/dashboard-tutorial.png" alt="Coming Soon" />

      <lib-button
        [type]="data.buttons.primary.type!"
        [label]="data.buttons.primary.text"
        size="Large"
        (onClick)="data.buttons.primary.action?.()"
      >
        {{ data.buttons.primary.text }}
      </lib-button>

      @if (data.buttons.secondary) {
        <div class="secondary-button">
          <lib-button
            [type]="data.buttons.secondary.type || 'Tertiary'"
            [label]="data.buttons.secondary.text"
            size="Large"
            (onClick)="data.buttons.secondary.action?.()"
            customColor="#FFFFFF"
          >
            {{ data.buttons.secondary.text }}
          </lib-button>
        </div>
      }
    </div>
  </div>
</div>
